import properties from '../constants/properties';
import Immutable from 'seamless-immutable';

/**
 * Validates the Epic property passed down in as props. epic_games is the default.
 * @param  {Object} props React.Component props
 * @return {String}       Property name
 */
const defaultPropName = (epicPropertyName) => {
    if (!epicPropertyName || !properties[epicPropertyName]) {
        console.warn(`Property ${epicPropertyName} is not supported!`);
        return 'epic_games'; //set the default if property doesn't exist
    }
    return epicPropertyName;
};

const getPropertyName = (epicPropertyName) => {
    return defaultPropName(epicPropertyName);
};

const getPropertyObject = (epicPropertyName) => {
    return Immutable(properties[defaultPropName(epicPropertyName)]);
};

export {
    getPropertyName,
    getPropertyObject
};



// WEBPACK FOOTER //
// ./app/scripts/utils/epicPropertyInspector.js